const imagesHelper = (repository) => (publication, remove = false) => {
  if(remove) return publication

  const advertorial = publication.advertorial
  if(advertorial.issue && advertorial.issue.cover_url) 
    advertorial.issue.cover_url = repository.baseMediaDomain + advertorial.issue.cover_url

  if(advertorial.pages) {    
    advertorial.pages = advertorial.pages.map(page => {
      if(page.screenshot) 
        page.screenshot = mediumFullUrlObject(repository, page.screenshot)

      if(page.medium)
        return { ...page, medium: mediumFullUrlObject(repository, page.medium) }

      if (page.media)
        return { ...page, media: page.media.map(medium => mediumFullUrlObject(repository, medium)) }
      return { ...page }
    })
  }

  if(advertorial.media) {
    advertorial.media = advertorial.media.map(medium => mediumFullUrlObject(repository, medium))
  }

  return { ...publication }
}

export const mediumFullUrl = (repository, partialUrl) => repository.baseMediaDomain + partialUrl

export const mediumFullUrlObject = (repository, medium) => {
  let mediumCopy = { ...medium }
  if(medium.url)
    mediumCopy['url'] = mediumFullUrl(repository, medium.url)
  if(medium.url_thumb)
    mediumCopy['url_thumb'] = mediumFullUrl(repository, medium.url_thumb)
  return mediumCopy
}

const rectsHelper = () => (publication, remove = false) => {
  if(!remove) {
    publication.rectsFor = function(index) {
      return this.advertorial.pages[index].medium.highlight_area || []
    }

    publication.updateRects = function(rects, index) {
      this.advertorial.pages[index].medium.highlight_area = rects
    }
  }
  else {
    delete publication.rectsFor
    delete publication.updateRects
  }
  
  return publication
}

const issueFieldHelper = () => (publication, remove = false) => {
  if(!remove) {
    const issue = publication.advertorial.magazine ||
                  publication.advertorial.website ||
                  publication.advertorial.newspaper ||
                  publication.advertorial.social
    delete publication.advertorial.magazine
    delete publication.advertorial.website
    delete publication.advertorial.newspaper
    delete publication.advertorial.social
    publication.advertorial['issue'] = { ...issue }
  }

  return publication
}

export { imagesHelper, rectsHelper, issueFieldHelper }